<template>
  <el-form ref="form" :model="formData" :rules="rules" label-position="top">
    <el-form-item
      v-for="(item, index) in computedRenderFormItems"
      :key="item.baseQuestionId"
      :label="`${index + 1}、${item.baseQuestionName}`"
      :prop="item.baseQuestionId"
    >
      <component
        :is="COMP_TYPE_ITEM[item.baseQuestionType]"
        v-model="formData[item.baseQuestionId]"
        :config="item"
        :editable="editable"
        :ref="`formItemCompRef_${item.baseQuestionId}`"
      ></component>
    </el-form-item>
  </el-form>
</template>

<script>
import { COMP_TYPE, COMP_TYPE_ITEM, INPUT_TYPE } from "./config";
export default {
  props: {
    formItems: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      COMP_TYPE: Object.freeze(COMP_TYPE),
      COMP_TYPE_ITEM: Object.freeze(COMP_TYPE_ITEM),
      INPUT_TYPE: Object.freeze(INPUT_TYPE),
      formData: {},
      rules: {},
    };
  },
  computed: {
    computedFormItems() {
      // 预处理外部传入的配置
      return this.formItems.map((item) => {
        return {
          ...item,
          baseQuestionId: String(item.baseQuestionId),
        };
      });
    },

    // 预处理需要渲染的表单项
    computedRenderFormItems() {
      const tempArr = [];
      this.computedFormItems.forEach((item) => {
        // 定位组件类型，加个tips
        // if (item.baseQuestionType === COMP_TYPE.LOCATION) {
        //   item = {
        //     ...item,
        //     tips: "（该项需要在小程序中操作获取）",
        //   };
        // } else {
        //   item = {
        //     ...item,
        //     tips: "",
        //   };
        // }
        // 判断是否有依赖
        if (item.displayDepend) {
          // 有依赖
          const targetValue = this.formData[item.displayDependBaseQuestionId];
          console.log(
            "this.formData[item.displayDependBaseQuestionId]----",
            targetValue
          );
          if (
            String(item.displayDependBaseQuestionOptionId) ===
            String(targetValue)
          ) {
            tempArr.push(item);
          }
        } else {
          tempArr.push(item);
        }
      });
      return tempArr;
    },
  },
  watch: {
    computedFormItems: {
      immediate: true,
      deep: true,
      handler() {
        this.initForm();
      },
    },
  },
  methods: {
    // 初始化表单
    initForm() {
      const formData = {};
      const rules = {};
      this.computedFormItems.forEach((item) => {
        const key = item.baseQuestionId;
        formData[key] = this.handleContent(item);
        console.log("formData[key]...", key, formData[key]);
        rules[key] = this.generateFormRuleByItemConfig(item);
      });
      this.formData = formData;
      this.rules = rules;
      console.log("dynamic-form。。。this.rules----", this.rules);
    },

    // 处理后端返回的content字段，转换为组件需要的格式
    handleContent(item) {
      const tempType = Number(item.baseQuestionType);
      if (
        tempType === COMP_TYPE.CHECKBOX ||
        tempType === COMP_TYPE.SELECT_MULTI ||
        tempType === COMP_TYPE.IMAGE_UPLOAD ||
        tempType === COMP_TYPE.FILE_UPLOAD ||
        tempType === COMP_TYPE.VIDEO_UPLOAD
      ) {
        let temp = [];
        try {
          temp = JSON.parse(item.content) || [];
        } catch (err) {
          // do nothing
        }
        return temp;
      }
      return item.content || "";
    },

    // 生成字段校验规则
    generateFormRuleByItemConfig(item) {
      console.log("generateFormRuleByItemConfig...item---", item);
      const rules = [];
      const tempInputLimitType = Number(item.baseQuestionLimitType);
      const tempType = Number(item.baseQuestionType);

      // 必填项
      if (item.baseQuestionRequire) {
        let tempMessage = `${item.baseQuestionName}不能为空`;
        if (tempType === COMP_TYPE.LOCATION) {
          // 定位为空，提示需要到小程序进行操作
          tempMessage = `请先暂存，然后到佰和云享小程序进行${item.baseQuestionName}操作`;
        }
        rules.push({
          required: true,
          message: tempMessage,
          trigger: "blur",
        });
      }
      // 字数限制，日期时间类不需要检验字数限制
      const isNotDateTimeType =
        tempType !== COMP_TYPE.DATE && tempType !== COMP_TYPE.DATETIME;
      console.log("isNotDateTimeType...", isNotDateTimeType);

      if (
        isNotDateTimeType &&
        (item.baseQuestionLimitMax || item.baseQuestionLimitMin)
      ) {
        var validateLimitMaxMin = (rule, value, callback) => {
          if (value) {
            if (Array.isArray(value)) {
              if (
                item.baseQuestionLimitMax &&
                value.length > item.baseQuestionLimitMax
              ) {
                return callback(
                  new Error(`最多上传${item.baseQuestionLimitMax}个文件`)
                );
              }
              if (
                item.baseQuestionLimitMin &&
                value.length < item.baseQuestionLimitMin
              ) {
                return callback(
                  new Error(`最少上传${item.baseQuestionLimitMin}个文件`)
                );
              }
            } else {
              if (
                item.baseQuestionLimitMax &&
                value.length > item.baseQuestionLimitMax
              ) {
                return callback(
                  new Error(`最多输入${item.baseQuestionLimitMax}个字`)
                );
              }
              if (
                item.baseQuestionLimitMin &&
                value.length < item.baseQuestionLimitMin
              ) {
                return callback(
                  new Error(`最少输入${item.baseQuestionLimitMin}个字`)
                );
              }
            }
          }
          callback();
        };

        rules.push({
          validator: validateLimitMaxMin,
          trigger: "blur",
        });
      }
      // 正整数
      if (tempInputLimitType === INPUT_TYPE.POSITIVE_INTERGER) {
        rules.push({
          pattern: /^[1-9]\d*$/,
          message: `${item.baseQuestionName}必须为正整数`,
          trigger: "blur",
        });
      }
      // 浮点数
      if (tempInputLimitType === INPUT_TYPE.FLOATING_NUMBER) {
        rules.push({
          pattern: /^\d+(\.\d+)?$/,
          message: `${item.baseQuestionName}必须为数字`,
          trigger: "blur",
        });
      }
      // 小数点位数限制
      if (item.baseQuestionLimitDecimal) {
        rules.push({
          pattern: new RegExp(
            `^\\d+(\\.\\d{0,${item.baseQuestionLimitDecimal}})?$`
          ),
          message: `${item.baseQuestionName}最多保留${item.baseQuestionLimitDecimal}位小数`,
          trigger: "blur",
        });
      }
      // 纯英文
      if (tempInputLimitType === INPUT_TYPE.ENG) {
        rules.push({
          pattern: /^[a-zA-Z]+$/,
          message: `${item.baseQuestionName}必须为英文`,
          trigger: "blur",
        });
      }
      // 纯数字
      if (tempInputLimitType === INPUT_TYPE.NUMBER) {
        rules.push({
          pattern: /^\d+$/,
          message: `${item.baseQuestionName}必须为数字`,
          trigger: "blur",
        });
      }
      return rules;
    },

    // 同步数据
    syncData() {
      for (let i = 0; i < this.computedFormItems.length; i++) {
        const item = this.computedFormItems[i];
        const refKey = `formItemCompRef_${item.baseQuestionId}`;
        const refCompItem = this.$refs[refKey] && this.$refs[refKey][0];
        if (refCompItem && refCompItem.getData) {
          const compData = refCompItem.getData();
          console.log("组件返回的数据：----", compData);
          if (compData) {
            this.formData[item.baseQuestionId] = compData;
          } else {
            // 还没能获取到结果，可能还在上传中
            return Promise.resolve(false);
          }
        }
      }
      return Promise.resolve(true);
    },

    // 校验表单
    validate() {
      return this.syncData().then((syncRes) => {
        if (!syncRes) {
          // // 同步数据失败
          return Promise.resolve(false);
        }
        // 同步数据成功，可以正常走校验
        return this.$refs.form.validate();
      });
    },

    // 获取数据
    getData() {
      const data = [];
      console.log("开始组装数据：", this.computedFormItems.length);
      for (let i = 0; i < this.computedFormItems.length; i++) {
        const item = this.computedFormItems[i];
        let submitContent = this.formData[item.baseQuestionId];
        if (Array.isArray(this.formData[item.baseQuestionId])) {
          submitContent = JSON.stringify(submitContent);
        }
        data.push({
          ...item,
          content: submitContent,
        });
      }
      console.log("getData得到组装后的数据----", data);
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
  color: #606266;
}
::v-deep .el-radio__input.is-disabled + span.el-radio__label {
  color: #606266;
}
::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner {
  border-color: #908e8e;
  background: #908e8e;
}
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #908e8e;
  border-color: #908e8e;
}
::v-deep .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
::v-deep .el-tag.el-tag--info {
  color: #606266;
}
</style>
